import * as React from 'react'
import { useSurvey } from '../hook/useSurvey'
import { WithSurveyProps } from './model'

const withSurvey = <T extends object>(WrappedComponent: React.FC<T>) => {
  const ComponentWithSurvey = (props: T & WithSurveyProps) => {
    const { isEnabled } = useSurvey()
    return (
      <WrappedComponent {...props} isSurveyEnabled={isEnabled} />
    )
  }

  ComponentWithSurvey.displayName = `withSurvey(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`

  return ComponentWithSurvey
}

export default withSurvey
